module.exports = __webpack_public_path__ + "img/team-list-icon.87166fb1.svg";